import Vue from 'vue'
import Hotjar from 'vue-hotjar'

Vue.use (Hotjar, {
  id: process.env.VUE_APP_HOTJAR_SITE_ID, // Hotjar Site ID
  isProduction: process.env.VUE_APP_FLUIDCOINS_ENV === 'production',
  snippetVersion: 6
})
